import { useMemo } from 'react';
import classNames from 'classnames';
import { useUserProfileStore } from 'src/stores/UserProfile';
import { useScreenSize } from '@ds/utils/hooks/useScreenSize';
import ProfileInfo from './ProfileInfo/ProfileInfo';
import ProfileTabs from './ProfileTabs/ProfileTabs';

const UserProfile = () => {
  const { editMode } = useUserProfileStore();
  const { isDesktop } = useScreenSize();

  const profileHeaderClass = useMemo(
    () =>
      classNames(
        'flex flex-col gap-4 -mt-4 pt-4 md:pb-4',
        isDesktop && editMode && 'sticky z-[1002] top-[68px] bg-white'
      ),
    [editMode, isDesktop]
  );

  return (
    <div>
      <section className={profileHeaderClass}>
        <h2 className="text-xl font-semibold">Profile</h2>
        <ProfileInfo />
      </section>
      <ProfileTabs />
    </div>
  );
};

export default UserProfile;
